import { Http } from '@/lib/http';

export class RoleService extends Http {
  constructor() {
    super();
    this.endpoint = 'settings/system-settings/roles/';
  }

  create(role) {
    return this.httpClient().post(`${this.endpoint}`, role);
  }

  findOne(id) {
    return this.httpClient().get(`${this.endpoint}${id}`);
  }

  findAll() {
    //filter = '', sort = '', { skip = 0, limit = -1 }
    const roleId = localStorage.getItem('roleId');
    localStorage.removeItem('roleId');
    //let query = `${sort}`;
    //query += limit < 1 ? '' : `&skip=${skip}&limit=${limit}&userId=${userId}`;
    return this.httpClient().get(`${this.endpoint}?roleId=${roleId}`);
  }

  update(id, role) {
    return this.httpClient().patch(`${this.endpoint}${id}`, role);
  }

  delete(id) {
    return this.httpClient().delete(`${this.endpoint}${id}`);
  }
}
